import { render, staticRenderFns } from "./Processes.vue?vue&type=template&id=8c61c7da&"
import script from "./Processes.vue?vue&type=script&lang=js&"
export * from "./Processes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c61c7da')) {
      api.createRecord('8c61c7da', component.options)
    } else {
      api.reload('8c61c7da', component.options)
    }
    module.hot.accept("./Processes.vue?vue&type=template&id=8c61c7da&", function () {
      api.rerender('8c61c7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Processes.vue"
export default component.exports